import React from "react";
import * as Lucide from "lucide-react";

// Map Feather icon names (from the original app) to lucide-react components.
const OVERRIDES = {
  tool: "PenTool",
  "edit-2": "Edit2",
  "edit-3": "Edit3",
  "bar-chart-2": "BarChart2",
  "link-2": "Link2",
  "trash-2": "Trash2",
  "refresh-cw": "RefreshCw",
  "check-circle": "CheckCircle",
  "x-circle": "XCircle",
  "help-circle": "HelpCircle",
  "message-circle": "MessageCircle",
  "alert-circle": "AlertCircle",
  "pause-circle": "PauseCircle",
  "dollar-sign": "DollarSign",
  "trending-up": "TrendingUp",
  "external-link": "ExternalLink",
  "shopping-bag": "ShoppingBag",
  "align-justify": "AlignJustify",
  "log-out": "LogOut",
  "credit-card": "CreditCard",
  "book-open": "BookOpen",
  "arrow-right": "ArrowRight",
  "arrow-left": "ArrowLeft",
  "arrow-up": "ArrowUp",
  "arrow-down": "ArrowDown",
  "chevron-right": "ChevronRight",
  "chevron-left": "ChevronLeft",
  "chevron-up": "ChevronUp",
  "chevron-down": "ChevronDown",
};

function toPascal(name) {
  return name
    .split("-")
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join("");
}

export function Icon({ name, size = 20, color = "currentColor", style, strokeWidth = 2, className }) {
  const key = OVERRIDES[name] || toPascal(name || "star");
  const Cmp = Lucide[key] || Lucide.Star;
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} style={style} className={className} />;
}
